import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "orders",
  class: "flex flex-col gap-3 pb-[150px]"
}
const _hoisted_2 = {
  key: 1,
  class: "absolute z-1 inset-0 flex items-center justify-center"
}
const _hoisted_3 = { class: "text-gray-500 w-40" }
const _hoisted_4 = {
  key: 2,
  id: "order-button",
  class: "fixed z-19 bottom-[80px] left-1/2 transform -translate-x-1/2 -translate-y-1/2"
}

import OrderCard from "@/components/orders/OrderCard.vue";
import { Order } from "@/data/interfaces/OrderInterface";
import { PropType, ref } from "vue";
import store from "@/store";
import { DbButton } from "@db-ui/v-elements-enterprise/dist/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderOverview',
  props: {
  orders: Array as PropType<Order[]>,
  readonly: {
    default: false,
  },
},
  emits: ["refreshData"],
  setup(__props) {



const props = __props;

const activeOrder = ref(null as string | null);

const setActiveOrder = (index: string) => {
  activeOrder.value = index;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(store)?.state?.OrderStore?.orders.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.orders, (order, index) => {
            return (_openBlock(), _createBlock(OrderCard, {
              key: index,
              index: index,
              order: (order as Order),
              readonly: __props.readonly,
              "active-order": (activeOrder.value as number | null),
              onRefreshData: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('refreshData'))),
              onActiveOrder: setActiveOrder
            }, null, 8, ["index", "order", "readonly", "active-order"]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("order.empty")), 1)
        ])),
    (activeOrder.value == null && !__props.readonly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_unref(DbButton), {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/orders/create'))),
            class: "hydrated",
            variant: "brand-primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("order.add")), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})